import React from "react";
import AppointmentsTable from "./AppointmentsTable";
import { HistoryFragment } from "./AppointmentCredits-generated.hooks";

interface AppointmentsTabProps {
  data: HistoryFragment[];
  loading: boolean;
  onRefetch: VoidFunction;
}

function AppointmentsTab(props: AppointmentsTabProps) {
  const { data, loading, onRefetch } = props;

  return (
    <AppointmentsTable data={data} loading={loading} onRefetch={onRefetch} />
  );
}

export default AppointmentsTab;
